import { produce } from "immer";
import { Store } from "reducers/rootReducer";

/* STATE */

type State = {
  brandLogo: string | null;
};

const initialState: State = {
  brandLogo: null,
};

/* ACTIONS */

const SAVE_BRAND_LOGO = "app/brandSettings/SAVE_BRAND_LOGO";

type Action = {
  type: typeof SAVE_BRAND_LOGO;
  payload: string;
};

/* REDUCER */

export default function reducer(state = initialState, action: Action): State {
  return produce(state, draft => {
    switch (action.type) {
      case SAVE_BRAND_LOGO:
        draft.brandLogo = action.payload;
        break;
      default:
        break;
    }
  });
}

/* ACTION CREATORS */

export const setBrandLogo = (logo: string): Action => ({
  type: SAVE_BRAND_LOGO,
  payload: logo,
});

/* SELECTORS */

export const selectBrandLogo = (app: Store) => app.brandSettings.brandLogo;
